export default __webpack_public_path__ + "static/media/sandal10.8aa19188.jpeg";